import React, { Component, createRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
import { Parser } from 'html-to-react';
import { ShareArticle } from '@surfline/quiver-react';
import { canUseDOM } from '@surfline/web-common';
import articlePropType from '../../propTypes/article';
import { articleProcessingInstructions } from './helpers';
import {
  renderArticleAds,
  renderIgElements,
  renderJWElements,
  trackArticleLinkClicks,
  renderVideoPaywalls,
  renderCalendarEvents,
  renderCameraEmbeds,
  renderTwitterElements,
} from '../../utils/renderCustomComponents';
import config from '../../config';
import EditorialPaywall from '../EditorialPaywall';

class EditorialArticleBody extends Component {
  constructor(props) {
    super(props);
    this.articleRef = createRef();
    this.htmlToReactParser = new Parser();
    this.isValidNode = () => true;
  }

  componentDidMount() {
    const {
      article: {
        id,
        createdAt,
        sponsoredArticle: { dfpKeyword },
        displayOptions: { hideAds },
        premium: { premium },
      },
      doTrackEvent,
      qaFlag,
      isPremium,
      native,
      doLoadTreatment,
    } = this.props;
    const children = [...this.articleRef.current.children];
    if (!hideAds && (dfpKeyword || !isPremium) && !premium) {
      renderArticleAds(this.articleRef, children, dfpKeyword, createdAt, qaFlag);
    }
    renderIgElements();
    renderTwitterElements();
    renderJWElements();
    trackArticleLinkClicks(id, doTrackEvent);

    // Render video paywalls if premium conditions are met and split is on
    const paywall = premium && !isPremium && !native;
    renderVideoPaywalls(
      this.doTrackVideoPaywallClicks,
      this.onClickPaywallSignIn,
      paywall,
      doLoadTreatment,
    );
    renderCalendarEvents(doTrackEvent, id);
    renderCameraEmbeds(isPremium);
  }

  onClickPaywallSignIn = () => {
    sessionStorage.setItem('redirectUrl', window.location.href);
  };

  doTrackVideoPaywallClicks = () => {
    const { doTrackEvent, article } = this.props;

    const tags = [];
    article.tags.forEach(tag => tags.push(tag.name));
    doTrackEvent('Clicked Subscribe CTA', {
      ctaLocation: 'Premium Article - Video Paywall',
      title: article.content.title,
      category: 'editorial',
      contentType: 'Editorial',
      contentId: article.id,
      tags,
      mediaType: article.media.type,
    });
    if (canUseDOM) window.location.assign(`${config.surflineHost}${config.funnelUrl}`);
  };

  render() {
    const { article, isPremium, onClickLink, native, doTrackEvent } = this.props;
    const paywalled = article.premium.premium && !isPremium && !native;
    const bodyContent = paywalled ? article.premium.teaser : article.content.body;
    return (
      <div>
        <div className="sl-editorial-article-body__container">
          <div
            ref={this.articleRef}
            id="sl-editorial-article-body"
            className="sl-editorial-article-body"
            dangerouslySetInnerHTML={{
              __html: ReactDOMServer.renderToStaticMarkup(
                this.htmlToReactParser.parseWithInstructions(
                  bodyContent,
                  this.isValidNode,
                  articleProcessingInstructions(isPremium),
                ),
              ),
            }}
          />
          {paywalled ? <div className="sl-editorial-paywall__fade" /> : null}
        </div>
        {!paywalled && article.tags.length ? (
          <ul className="sl-article-tags">
            {article.tags.map(tag => (
              <li key={tag.name}>
                <a href={tag.url}>{tag.name}</a>
              </li>
            ))}
          </ul>
        ) : null}
        {!paywalled ? (
          <div className="sl-editorial-article-bottom__social">
            <hr />
            <h6>Share this story</h6>
            <ShareArticle url={article.permalink} onClickLink={onClickLink} />
          </div>
        ) : (
          <EditorialPaywall
            article={article}
            premium={article.premium}
            doTrackEvent={doTrackEvent}
          />
        )}
      </div>
    );
  }
}

EditorialArticleBody.propTypes = {
  article: articlePropType.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  isPremium: PropTypes.bool,
  qaFlag: PropTypes.string,
  onClickLink: PropTypes.func.isRequired,
  native: PropTypes.bool,
  doLoadTreatment: PropTypes.func.isRequired,
};

EditorialArticleBody.defaultProps = {
  isPremium: false,
  qaFlag: null,
  native: false,
};

export default EditorialArticleBody;
